const currencySymbols = { 'ZAR': 'c' } as const

type Config = Partial<{
  currency: keyof typeof currencySymbols
  showSymbol: boolean
  maxScale: number
  minScale: number
}>

export function formatCents(value: number|null|undefined, config: Config = { }): string|undefined {
  if (typeof value !== 'number' || isNaN(value)) {
    return undefined
  }

  const { currency = 'ZAR', showSymbol = false, maxScale = 2, minScale = 1 } = config

  const formattedValue = new Intl.NumberFormat(
    "en-US",
    {
      style: 'decimal',
      maximumFractionDigits: maxScale,
      minimumFractionDigits: minScale,
    }
  ).format(value).replace(/,/g, ' ')

  if (!showSymbol) {
    return formattedValue
  }

  return `${formattedValue}${currencySymbols[currency]}`
}
